import axios from 'axios';

const EditTask =  async (data, onSuccess, onError)=>{
    try{
        const response = await axios.post("/edit/task", data, {
            headers: {
                "Content-Type": "application/json"
            },
            withCredentials: true,
            // baseURL: "https://shielded-lowlands-66092.herokuapp.com/"
            baseURL: "https://salty-reaches-69347.herokuapp.com/"
        });
        console.log(response.data.status);
        onSuccess && onSuccess(response);
    }
    catch(err){
        console.log(err);
        onError && onError(err);
    }
};

export default EditTask;